import React from 'react';
import { FormattedMessage } from 'react-intl';
import withProps from 'recompose/withProps';

import Text from './Text';

export const SingleDevicePriceFootnote = withProps({
  muted: true,
  level: 4,
  children: (
    <FormattedMessage
      id="priceFootnotes.device.singlePriceQualifier"
      defaultMessage="single Butterfly iQ"
    />
  ),
})(Text);

export const DevicePriceFootnote = withProps({
  muted: true,
  level: 4,
  children: (
    <FormattedMessage
      id="priceFootnotes.device.priceQualifier"
      defaultMessage="per Butterfly iQ"
    />
  ),
})(Text);

export const SingleUserPriceFootnote = withProps({
  muted: true,
  level: 3,
  children: (
    <FormattedMessage
      id="priceFootnotes.users.singlePriceQualifier"
      defaultMessage="billed annually"
    />
  ),
})(Text);

export const UserPriceFootnote = withProps({
  muted: true,
  level: 3,
  children: (
    <FormattedMessage
      id="priceFootnotes.users.priceQualifier"
      defaultMessage="per user, billed annually"
    />
  ),
})(Text);

export const BilledAnnually = withProps(p => ({
  muted: true,
  level: 3,
  children: p.parens ? (
    <>
      (
      <FormattedMessage
        id="priceFootnotes.billedAnnually"
        defaultMessage="billed annually"
      />
      )
    </>
  ) : (
    <FormattedMessage
      id="priceFootnotes.billedAnnually"
      defaultMessage="billed annually"
    />
  ),
  ...p,
}))(Text);

export const ButterflyIqLightningFootnote = withProps({
  muted: true,
  level: 3,
  children: (
    <FormattedMessage
      id="deviceFootnotes.butterflyIqLightningDescription"
      defaultMessage="Lightning cable 1.25m long. For iPhones and some iPads."
    />
  ),
})(Text);

export const ButterflyIqUsbcFootnote = withProps({
  muted: true,
  level: 3,
  children: (
    <FormattedMessage
      id="deviceFootnotes.butterflyIqUsbcDescription"
      defaultMessage="USB-C cable 2m long. For latest iPad Pro models."
    />
  ),
})(Text);
